var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isNotNullOrEmpty, removeKeys } from '@pcty/utils';
import isEqual from 'lodash/isEqual';
import React from 'react';
import getDisplayedData from '../utils/getDisplayedData';
import { SELECTION_TYPES } from './constants';
import TableCore from './TableCore';
import { default as TablePage } from './TablePage';
var _defaultProps = {
    disabled: false,
    editId: undefined,
    errorIds: [],
    equalColumnWidths: true,
    expandedIds: [],
    fixedHeader: false,
    fixedLeftColumns: 0,
    fixedRightColumns: 0,
    loading: false,
    lowerPager: true,
    pager: true,
    onChangeSelection: function () { return undefined; },
    renderToolbar: function () { return undefined; },
    selected: [],
    upperPager: true,
    warningIds: [],
    __TYPE: 'Table',
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.state = getInitialState(props);
        _this.onChange = _this.onChange.bind(_this);
        _this.onChangeExpanded = _this.onChangeExpanded.bind(_this);
        _this.onChangeSelection = _this.onChangeSelection.bind(_this);
        _this.updateState = function (state, callback) {
            _this.setState(__assign(__assign({}, state), { stateUpdate: true }), callback);
        };
        return _this;
    }
    Table.getDerivedStateFromProps = function (props, state) {
        var _a;
        if (state.stateUpdate) {
            return __assign(__assign({}, state), { stateUpdate: false, props: props });
        }
        var newState = {};
        if (!isEqual(props.data, state.props.data)) {
            // Reset state with new props if data has changed
            return getInitialState(props);
        }
        if (!isEqual(props.selected, state.props.selected)) {
            newState = __assign(__assign({}, newState), { selection: getSelection(props.data, (_a = props.selected) !== null && _a !== void 0 ? _a : []) });
        }
        return isNotNullOrEmpty(newState) ? __assign(__assign(__assign({}, state), newState), { props: props }) : null;
    };
    Table.prototype.onChange = function (pageConfig) {
        var display = getDisplayedData(this.props.data, pageConfig);
        this.updateState({ display: display, pageConfig: pageConfig });
    };
    Table.prototype.onChangeExpanded = function (expandedIds) {
        this.props.onChangeExpanded(expandedIds);
    };
    Table.prototype.onChangeSelection = function (selection) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        switch (selection.type) {
            case SELECTION_TYPES.all:
                (_b = (_a = this.props).onChangeSelection) === null || _b === void 0 ? void 0 : _b.call(_a, this.props.data);
                break;
            case SELECTION_TYPES.allExcept:
                var exceptions_1 = selection.items.map(function (x) { return x[_this.props.primaryKey]; });
                var selected = this.props.data.filter(function (x) { return exceptions_1.indexOf(x[_this.props.primaryKey]) === -1; });
                (_d = (_c = this.props).onChangeSelection) === null || _d === void 0 ? void 0 : _d.call(_c, selected);
                break;
            case SELECTION_TYPES.individual:
            default:
                (_f = (_e = this.props).onChangeSelection) === null || _f === void 0 ? void 0 : _f.call(_e, selection.items);
                break;
        }
    };
    Table.prototype.render = function () {
        var other = removeKeys(this.props, [
            'automationId',
            'children',
            'className',
            'css',
            'data',
            'disabled',
            'editId',
            'errorIds',
            'equalColumnWidths',
            'expandedIds',
            'fixedHeader',
            'fixedLeftColumns',
            'fixedRightColumns',
            'highlight',
            'loading',
            'lowerPager',
            'onChangeSelection',
            'pageConfig',
            'primaryKey',
            'renderState',
            'renderToolbar',
            'renderToolbarFooter',
            'renderZeroState',
            'selected',
            'showOutliers',
            'upperPager',
            'warningIds',
            '__TYPE',
        ]);
        return (React.createElement(TablePage, __assign({}, other, { automationId: this.props.automationId, className: this.props.className, css: this.props.css, data: this.state.display, disabled: this.props.disabled || isNotNullOrEmpty(this.props.editId), editId: this.props.editId, errorIds: this.props.errorIds, expandedIds: this.props.expandedIds, fixedHeader: this.props.fixedHeader, fixedLeftColumns: this.props.fixedLeftColumns, fixedRightColumns: this.props.fixedRightColumns, highlight: this.props.highlight, itemCount: this.props.data.length, loading: this.props.loading, lowerPager: this.props.lowerPager, onChange: this.onChange, onChangeExpanded: this.onChangeExpanded, onChangeSelection: this.onChangeSelection, pageConfig: this.state.pageConfig, pager: this.props.pager, primaryKey: this.props.primaryKey, renderState: this.props.renderState, renderToolbar: this.props.renderToolbar, renderToolbarFooter: this.props.renderToolbarFooter, renderZeroState: this.props.renderZeroState, selection: this.state.selection, showOutliers: this.props.showOutliers, upperPager: this.props.upperPager, warningIds: this.props.warningIds }), this.props.children));
    };
    Table.Core = TableCore;
    Table.Page = TablePage;
    Table.defaultProps = _defaultProps;
    return Table;
}(React.Component));
var getInitialState = function (props) {
    var _a;
    return ({
        display: getDisplayedData(props.data, props.pageConfig),
        props: props,
        pageConfig: props.pageConfig,
        selection: getSelection(props.data, (_a = props.selected) !== null && _a !== void 0 ? _a : []),
        stateUpdate: false,
    });
};
var getSelection = function (data, selected) { return ({
    type: data.length === selected.length ? SELECTION_TYPES.all : SELECTION_TYPES.individual,
    items: data.length === selected.length ? [] : selected,
    selectedCount: selected.length,
}); };
export default Table;
